class FamilyView {

    constructor(controller) {
        this.rootNode = $('.module--family');
        this.relationshipRadio = $('.relationship');
        this.relationshipTime = $('#partnertime');
        this.childrenRadio = $('.app-children');
        this.childActivityOptionViews = this.rootNode.find('.child-activity-option').map(function(i, node){
            return new FamilyChildActivityOptionView($(node), controller);
        });

    }
}

class FamilyChildActivityOptionView {

    constructor(node, controller) {
        this.controller = controller;
        this.node = node;
        this.optionNo = parseInt(node.attr('data-option'));
        this.selectCheckbox = this.node.find('.childActivityOption_check');
        this.dayAndHoursSelector = new DayAndHoursSelector(this.node,
            this.onHoursSelectionChanged.bind(this),
            this.onDaySelectionChanged.bind(this));

        this.controller.initialiseChildOption(this);
    }

    onHoursSelectionChanged(hours) {
        this.controller.onHoursSelectionChanged(this, hours);
    }

    onDaySelectionChanged(days) {
        this.controller.onDaySelectionChanged(this, days);
    }
}

